import React, { ReactNode } from 'react'
import parse, { HTMLReactParserOptions, domToReact, Element, DOMNode } from 'html-react-parser'
import { Link } from 'react-router'

const parseHtmlWithReactLinks = (html: string): ReactNode => {
  const options: HTMLReactParserOptions = {
    replace(domNode) {
      if (domNode.type === 'tag'
        && domNode.name === 'a'
        && (domNode as Element).attribs
        && domNode.attribs?.href?.startsWith('/')
      ) {
        const element = domNode as Element
        const href = element.attribs.href
        const children = element.children as DOMNode[]

        return (
          <Link to={href}>
            {domToReact(children, options)}
          </Link>
        )
      }

      return undefined
    },
  }

  return parse(html, options)
}

export default parseHtmlWithReactLinks
